import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ControlGroup, CheckboxGroupField } = designSystem;
const defaultRules = {};

const CheckboxGroupFieldWrapper = ({
  name,
  title,
  options,
  description = '',
  control,
  rules = defaultRules,
}) => (
  <ControlGroup required title={title} description={description}>
    <CheckboxGroupField options={options} control={control} rules={rules} name={name} />
  </ControlGroup>
);

CheckboxGroupFieldWrapper.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      isLabelBold: PropTypes.bool,
    })
  ).isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
};

export default CheckboxGroupFieldWrapper;
